import apis from "../../core/apis.js";

class ReservationResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.reservation).get(options);
  }

  get(id) {
    return this.$resource(apis.reservation + id).get();
  }

  search(search = "") {
    return this.$resource(apis.reservation).get({ search });
  }

  post(item) {
    return this.$resource(apis.reservation).save(item);
  }

  update(id, item) {
    return this.$resource(apis.reservation + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  delete(id) {
    return this.$resource(apis.reservation + id).delete();
  }
}

export default ReservationResource;



// WEBPACK FOOTER //
// ./src/resources/reservation/reservation.resource.js